import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

// components
import FollowUs from '../vue/components/common/FollowUs.vue';

export default {
    init () {
        new Vue({
            render (createElement) {
                return createElement(FollowUs);
            },
        }).$mount('#vue-follow-us');
    },
    finalize () {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateTopics.js